import CheckoutGuaranties from './CheckoutGuaranties';

export default CheckoutGuaranties;
